

import React from "react";
import { CheckCircle } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Speed Up Conversions with WhatsApp Commerce",
    points: [
      "Greet leads warmly and follow up fast to lock in interest.",
      "Automate replies to keep prospects engaged and moving forward.",
      "Guide customers through loans and investments with personal help.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Banking_Finance/Banking_Finance_2.png",
  },
  {
    heading: "Cut Drop-Offs with a Smooth Financial Journey",
    points: [
      "Onboard customers easily with interactive WhatsApp chats.",
      "Collect key details and guide them to the next step seamlessly.",
      "Share helpful PDFs and videos about your services.",
    ],
    // buttonText: "Get Start ",
    buttonText: "Meta Policy for Banking",
    buttonLink:"https://transparency.meta.com/en-gb/policies/ad-standards/deceptive-content/prohibited-financial-products-and-services/",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Banking_Finance/Banking_Finance_3.png",
  },
  {
    heading: "Build Loyalty with Great Post-Purchase Support",
    points: [
      "Remind customers about payments with friendly nudges.",
      "Alert them to transfer limits and account changes.",
      "Help with account details and interest rate questions.",
      "Make updates and password resets a breeze.",
      "Send e-invoices, policies, and receipts instantly.",
      "Support credit card needs like blocking or upgrading.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Banking_Finance/Banking_Finance_4.png",
  },
];

const Bankingcycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-blue-100 via-blue-200 to-blue-300 py-12 px-6 text-center">
        <h1 className="text-4xl font-bold text-gray-900">How WhatsApp Digitizes Banking & Finance</h1>
        <div className="w-16 h-1 bg-gray-600 my-4 mx-auto rounded-full"></div>
        <p className="text-xl text-gray-700 max-w-3xl mx-auto">See how BFSI businesses use WhatsApp to create smooth, personal experiences that keep customers happy and engaged.</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Bankingcycle;